import React from "react";
import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Nav from "./Nav";
import Profile from "./Profile";
import About from "./About";
import AboutRoute from "./AboutRoute";
import SkillRoute from "./SkillRoute";
import Error from './Error'

function App() {
  return (
    <Router>
      <div className="App">
            <Nav />
        <Switch>
           <Route exact path="/">
            <Profile />
            <About />
          </Route>
          <Route path="/about">
            <Profile />
            <AboutRoute />
          </Route>
          <Route path="/skills">
            <Profile />
            <SkillRoute />
          </Route>
          <Route path="*">
            <Error />
         </Route>
        </Switch>
        <div className="copyright">
          <h2>&copy; 2020 YahiyaKhan</h2>
        </div>
      </div>
    </Router>
  );
}

export default App;
